import { Dialog, TextField } from "@mui/material";
import { useState } from "react";
import DialogContentSelectGeneric from "./DialogsContents/DialogContentGeneric";
import { defValueMeiosPagamento, IDataMeiosPagamento } from "../../types/api/financeiro/pesquisar-meios-pagamento";

export default function SelectMeioPagamento({
    value,
    onChange,
    required = false,
    error = false,
    extraParams = {}
}: SelectSimpleApiQueryProps) {

    const [openModal, setOpenModal] = useState(false)

    const handleClose = () => setOpenModal(false)

    const inputLabel = value ? `${value.id ?? ''}${value.nome ? ` - ${value.nome}` : ''}` : ""

    return (
        <>
            <TextField
                {...{ required, error }}
                label={`Meio de pagamento`}
                variant="outlined"
                fullWidth
                onClick={() => setOpenModal(true)}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        setOpenModal(true);
                    }
                }}
                slotProps={{
                    input: { readOnly: true }
                }}
                value={inputLabel}
                helperText={error ? "Campo obrigatório" : ""}
            />

            {
                openModal &&
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelectGeneric
                        {...{ handleClose, extraParams }}
                        title="Selecionar forma de pagamento"
                        queryPath="/financeiro/pesquisar-meios-pagamento"
                        getItemKey={(item) => item.id}
                        defaultValue={value || defValueMeiosPagamento}
                        getItemLabel={(item) => `${item.id} - ${item.nome}`}
                        onChange={(value) => {
                            onChange(value as IDataMeiosPagamento)
                            handleClose()
                        }}
                    />
                </Dialog>
            }
        </>
    )
}

interface SelectSimpleApiQueryProps {
    value: IDataMeiosPagamento | null
    onChange: (arg: IDataMeiosPagamento | null) => void
    required?: boolean
    error?: boolean
    extraParams?: { [key: string]: any };
}